module.exports = __webpack_public_path__ + "static/learn-hack-create-106ab4a1ec3e1be9c7d24fd968c1628e.jpg";